import { useEffect, useState, useCallback } from "react";
import Lenis from "lenis";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Role from "@/components/Role";
import Scope from "@/components/Scope";
import Team from "@/components/Team";
import Contact from "@/components/Contact";
import VideoModal from "@/components/VideoModal";
import HexDivider from "@/components/HexDivider";

function App() {
  const [activeVideo, setActiveVideo] = useState(null);
  const play = useCallback((v) => setActiveVideo(v), []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain bg-ink text-slate-100 min-h-screen">
      <Nav />
      <main>
        <Hero onPlay={play} />
        <Marquee />
        <About />
        <HexDivider />
        <Role onPlay={play} />
        <HexDivider />
        <Scope />
        <HexDivider />
        <Team />
        <HexDivider />
        <Contact />
      </main>
      <VideoModal video={activeVideo} onClose={() => setActiveVideo(null)} />
    </div>
  );
}

export default App;
